import testQuestionsActions from '../actions/TestQuestionsActions';

export default function (state = {}, action) {
    switch (action.type) {
    case testQuestionsActions.types.SET_NEXT_QUESTION_ID:
        return Object.assign({}, state, action.questionId, action.nextQuestionRevisionId, {
            [action.questionId]: {
                ...state[action.questionId],
                nextQuestionId: action.nextQuestionRevisionId,
            },
        });

    default:
        return state;
    }
}
